import Typography from "@mui/material/Typography";
import React from "react";
import AdminGamedayView from "./AdminGamedayView";
import { PageHeader } from "./PageHeader";

const SpielplanPage: React.FC = () => {
  return (
    <>
      <PageHeader title={"Spielplan"} withStatistiksNav={true} />

      <AdminGamedayView />

      <Typography>
        Hier finden Sie den aktuellen Spielplan der WBL Steeldartliga
        Baden-Württemberg. Alle Begegnungen, Termine und Spielorte auf einen
        Blick.
      </Typography>
    </>
  );
};

export default SpielplanPage;
